module.exports = __webpack_public_path__ + "static/img/96-1.2e4b88d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/96-1.jpg
// module id = ym4O
// module chunks = 0